import React, { useContext } from "react";
import Typography from "@mui/material/Typography";
import useStyles from "./modalStyles";
import ModalTitleContext from "./ModalTitleContext";

const ModalTitle = ({ title }) => {
  const styles = useStyles();
  const titleId = useContext(ModalTitleContext);

  return (
    <Typography component="h2" id={titleId} className={styles.title}>
      {title}
    </Typography>
  );
};

export default ModalTitle;
